const state = () => ({
  ticket: null,
  tickets: [],
  ticketsCount: 0
});

const getters = {
  tickets: state => {
    return state.tickets;
  },
  ticket: state => {
    return state.ticket;
  },
  ticketsCount: state => {
    return state.ticketsCount;
  }
};

const actions = {
  async fetchTicket({ commit }, { id }) {
    const { data } = await this.$http.get(`tickets/${id}`);
    commit("setTicket", data);
  },
  async fetchTickets({ commit }) {
    const { data } = await this.$http.get("tickets");
    commit("setTickets", data);
  },
  async createTicket({ commit }, { payload }) {
    await this.$http.post("tickets", payload);
  },
  async countTickets({ commit }) {
    const { data } = await this.$http.get("tickets/count");
    commit("setTicketsCount", data);
  }
};

const mutations = {
  setTickets(state, data) {
    state.tickets = data;
  },
  setTicket(state, data) {
    state.ticket = data;
  },
  setTicketsCount(state, data) {
    state.ticketsCount = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
